import { ServiceHandler } from '../utils';

const getFiltersHandler = ServiceHandler({ url: '/api/user/v1/filter' });
export const getFilters = (params = {}) => getFiltersHandler({ params });

const getFilterHandler = ServiceHandler({ url: '/api/user/v1/filter/:id' });
export const getFilter = ({ id }) => getFilterHandler(id);

const createFilterHandler = ServiceHandler({
  url: '/api/user/v1/filter',
  method: 'post',
});
export const createFilter = (_params = {}, data) =>
  createFilterHandler({ data });

/**
 * A chip: a filter shown to everyone using a table, rather than to the person who saved it.
 *
 * <p>Its own endpoint because it is its own thing. The service sets `chip` itself and never
 * records a userEmail, and only an administrator may call it.
 */
const createChipHandler = ServiceHandler({
  url: '/api/user/v1/filter/chip',
  method: 'post',
});
export const createChip = (_params = {}, data) => createChipHandler({ data });

const deleteChipHandler = ServiceHandler({
  url: '/api/user/v1/filter/chip/:id',
  method: 'delete',
});
export const deleteChip = ({ id }) => deleteChipHandler(id);

const updateChipHandler = ServiceHandler({
  url: '/api/user/v1/filter/chip/:id',
  method: 'put',
});
export const updateChip = ({ id }, data) => updateChipHandler(id, { data });

/**
 * Removing one of a person's own saved filters.
 *
 * <p>Both filter-state hooks used to call this with a bare axios and an Authorization header
 * they had read at render time. See {@link getFiltersByTable}.
 */
const deleteSavedFilterHandler = ServiceHandler({
  url: '/api/user/v1/filter/:id',
  method: 'delete',
});
export const deleteSavedFilter = ({ id }) => deleteSavedFilterHandler(id);

const getFiltersByTableHandler = ServiceHandler({
  url: '/api/user/v1/filter/name/:table',
});
/**
 * A table's filters and chips.
 *
 * <p>`size` is passed because the service pages this endpoint and defaults to twenty, and returns
 * the page unsorted -- so a table holding more than twenty loses the rest, and which ones go
 * missing changes between calls.
 *
 * <p>Call this rather than issuing the request yourself. The shared `Api` request interceptor
 * reads the access token at request time; a component that reads it during render sends whatever
 * was current when it last rendered, and the token lives five minutes -- so a listing left open
 * across a refresh answers 401 until something unrelated re-renders it.
 */
export const getFiltersByTable = ({ table, size }) =>
  getFiltersByTableHandler(table, size ? { params: { size } } : undefined);

const postSystemFilterHandler = ServiceHandler({
  url: '/api/user/v1/filter/system/:email',
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
});
export const postSystemFilter = ({ email }, data) =>
  postSystemFilterHandler(email, { data });
